import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const FabricAdditionalAttributesTag = React.forwardRef((t0, ref) => {
  const $ = _c(7);
  const {
    children,
    isCleaningCode: t1
  } = t0;
  const isCleaningCode = t1 === undefined ? false : t1;
  const t2 = !isCleaningCode;
  let t3;
  if ($[0] !== isCleaningCode || $[1] !== t2) {
    t3 = classNames("text-xs font-bold bg-gray-light8 text-gray-light1 px-2 py-1 mt-2 mr-1 mb-1 ml-0 flex flex-row items-center capitalize rounded-[.125rem]", {
      "cursor-default": t2,
      "cursor-pointer": isCleaningCode
    });
    $[0] = isCleaningCode;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== ref || $[5] !== t3) {
    t4 = <div className={t3} ref={ref}>{children}</div>;
    $[3] = children;
    $[4] = ref;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
});
FabricAdditionalAttributesTag.propTypes = {
  children: PropTypes.node.isRequired,
  isCleaningCode: PropTypes.bool
};
export default FabricAdditionalAttributesTag;